import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import clsx from 'clsx';
import { machineStatuses } from '../../../Config/constants';
import { scissorTypes } from '../../../Config/scissorStates'
import { dataService } from '../../../Services/data.service';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Timer from '../../Shared/Timer';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Cleaning, Rupture } from '../../../Config/constants'

export const WorkstationStatusContent = (props) => {
    const classes = useStyles();
    const [refresh, setRefresh] = useState(false)
    const [startTime, setStartTime] = useState(null)

    useEffect(() => {
        let sortedStatusses = props.line.scissorStatuses.sort((a, b) => (new Date(b.startedOn)) - (new Date(a.startedOn)))
        let recentStatus = sortedStatusses[0]
        if (JSON.stringify(startTime) !== JSON.stringify(recentStatus.startedOn)) {
            setStartTime(recentStatus.startedOn)
        }
    }, [refresh])

    const refreshStatus = () => {
        setRefresh(!refresh)
    }

    let sortedStatusses = props.line.scissorStatuses.sort((a, b) => (new Date(b.startedOn)) - (new Date(a.startedOn)))

    let recentStatus = sortedStatusses[0]
    let icon = ''
    let statusColor = ""
    let status = ""
    if (recentStatus.name === machineStatuses.SCRAP) {
        status = machineStatuses.SCRAP
        icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
        statusColor = "#F59128";
    }
    else if (recentStatus.name === machineStatuses.UNPLANNEDSTOP) {
        status = machineStatuses.UNPLANNEDSTOP
        statusColor = "#D84949";
        icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
    }
    else if (recentStatus.name === machineStatuses.PLANNEDSTOP) {
        status = machineStatuses.PLANNEDSTOP
        statusColor = FlagstoneTheme.palette.primary.main;
        icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
    }
    else {
        status = machineStatuses.PRODUCTION;
        statusColor = "#5CC958";
        icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
    }

    const changeWorkstationStatus = (status) => {
        let tempMachineScissorStates = props.workstationState.workstationsWithScissorStatusInfo.slice();
        let stopMachine = true
        let plannedStop = true
        let upperScrap = false
        let lowerScrap = false
        let machineId = props.line.id
        let machineLowerStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
        let machineUpperStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
        if (status === machineStatuses.PRODUCTION) {
            stopMachine = false
            plannedStop = false
            machineLowerStatus.name = machineStatuses.PRODUCTION
            machineUpperStatus.name = machineStatuses.PRODUCTION
            machineLowerStatus.foregroundColorInHex = "#5CC958"
            machineUpperStatus.foregroundColorInHex = "#5CC958"
            machineLowerStatus.backgroundColorInHex = "#5CC9581A"
            machineUpperStatus.backgroundColorInHex = "#5CC9581A"
            machineUpperStatus.startedOn = new Date()
        }
        else if (status === machineStatuses.SCRAP) {
            machineLowerStatus.name = machineStatuses.SCRAP
            machineLowerStatus.foregroundColorInHex = "#F59127"
            machineLowerStatus.backgroundColorInHex = "#F591271A"
            machineLowerStatus.startedOn = new Date()
            lowerScrap = true
            plannedStop = false
            machineUpperStatus.name = machineStatuses.SCRAP
            machineUpperStatus.foregroundColorInHex = "#F59127"
            machineUpperStatus.backgroundColorInHex = "#F591271A"
            machineUpperStatus.startedOn = new Date()
            upperScrap = true
            stopMachine = false
        } else if (status === machineStatuses.UNPLANNEDSTOP) {
            machineLowerStatus.name = machineStatuses.UNPLANNEDSTOP
            machineUpperStatus.name = machineStatuses.UNPLANNEDSTOP
            machineLowerStatus.foregroundColorInHex = "#D84949"
            machineUpperStatus.foregroundColorInHex = "#D84949"
            machineLowerStatus.backgroundColorInHex = "#D849491A"
            machineUpperStatus.backgroundColorInHex = "#D849491A"
            machineUpperStatus.startedOn = new Date()
            plannedStop = false
            dataService.machineStoppedReason(machineId, Rupture, "", props.user.userInfo.given_name).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
        else {
            machineLowerStatus.name = machineStatuses.PLANNEDSTOP
            machineUpperStatus.name = machineStatuses.PLANNEDSTOP
            machineLowerStatus.foregroundColorInHex = "#4654FB"
            machineUpperStatus.foregroundColorInHex = "#4654FB"
            machineLowerStatus.backgroundColorInHex = "#4654FB1A"
            machineUpperStatus.backgroundColorInHex = "#4654FB1A"
            machineUpperStatus.startedOn = new Date()
            dataService.machineStoppedReason(machineId, Cleaning, "", props.user.userInfo.given_name).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
        props.actions.setUpdatedWorkstationId(machineId)
        props.actions.setWorkstationWithScissorStatusInfo(tempMachineScissorStates)

        dataService.changeMachineStatus(stopMachine, plannedStop, machineId, upperScrap, lowerScrap).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    }

    return (
        <React.Fragment>
            {props.dashboard.statusBoard && <div className={classes.header}>
                <div className={classes.statusContainer}>
                    <div className={classes.label}>
                        Machine status
                    </div>
                    <div className={classes.status}>
                        <div className={classes.statusIcon} style={{ color: statusColor }}>
                            {icon}
                        </div>
                        <div className={classes.statusText} style={{ color: statusColor }}>
                            {status}
                        </div>
                    </div>
                </div>
                <div className={classes.duration}>
                    {startTime && <Timer refresh={refreshStatus} startTime={startTime} line={props.line} actions={props.actions} ></Timer>}
                </div>
            </div>}
            {props.dashboard.changeStatusBoard && <div className={classes.statusList}>
                {!props.dashboard.statusBoard &&
                    <div className={classes.label} style={{ paddingLeft: "5px" }}>
                        Change machine status
                    </div>}
                <List>
                    {props.statusses.map(x => (<button className={classes.statusButton} onClick={() => changeWorkstationStatus(x.type)} key={x.id}><ListItem style={{ borderRadius: x.id === 1 ? "6px 6px 0  0" : x.id === props.statusses.length ? "0  0 6px 6px" : "" }} className={clsx({ [classes.warningListItem]: x.type === status && x.type === machineStatuses.SCRAP, [classes.errorListItem]: x.type === status && x.type === machineStatuses.UNPLANNEDSTOP, [classes.runningListItem]: x.type === status && x.type === machineStatuses.PRODUCTION, [classes.plannedStopListItem]: x.type === status && x.type === machineStatuses.PLANNEDSTOP, [classes.notActiveListItem]: x.type !== status })}>
                        <div className={classes.description}>{x.description}</div>
                        {x.type === status ? <div className={classes.statusDuration}>{startTime && <Timer refresh={refreshStatus} startTime={startTime} line={props.line} actions={props.actions} ></Timer>}
                        </div> : <div className={classes.arrowContainer}><ArrowForwardIosIcon className={classes.arrowForward}></ArrowForwardIosIcon></div>}
                    </ListItem></button>
                    )
                    )}
                </List>

            </div>}
        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    statusContainer: {
        width: "70%",
        display: 'inline-block'
    },
    duration: {
        width: "30%",
        display: 'inline-block',
        textAlign: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#020100',
        paddingTop: "10px"
    },
    statusIcon: {
        float: 'left',
        marginTop: "8px",
        marginRight: "3px"
    },
    errorIcon: {
        width: "27px",
        height: "27px"
    },
    infoIcon: {
        width: "27px",
        height: "27px"
    },
    statusText: {
        float: 'left',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textTransform: "capitalize",
        paddingTop: "4px",
        paddingLeft: "5px"
    },
    label: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#8D8D8D'
    },
    runningListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: '#5CC958',
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #5CC958"
    },
    warningListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: '#F59127',
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #F59127"

    },
    errorListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: '#D84949',
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #D84949"
    },
    plannedStopListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: FlagstoneTheme.palette.primary.main,
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid " + FlagstoneTheme.palette.primary.main
    },
    notActiveListItem: {
        backgroundColor: "#4654FB22",
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        paddingTop: "10px",
        paddingBottom: "10px",
        cursor: "pointer"

    },
    header: {
        marginBottom: "5px"
    },
    statusDuration: {
        fontSize: "13px !important",
        fontFamily: "Lato, sans-serif",
        fontWeight: "normal",
        color: '#8D8D8D',
        float: "right",
        width: "calc(100% - 150px)",
        textAlign: "right"
    },
    description: {
        width: "150px"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "right",
    },
    arrowContainer: {
        float: "left",
        width: "calc(100% - 150px)",
        textAlign: "right"
    },
    statusButton: {
        width: "100%",
        border: "none",
        outline: "none",
        backgroundColor: "white"
    }
}));

function mapStateToProps(state) {
    return {
        dashboard: state.dashboard
    }
}

export default connect(mapStateToProps)(WorkstationStatusContent)